import React, { FunctionComponent } from 'react'
import { useIntl } from 'react-intl'

import styled from 'styled-components/native'

import auroraPreferencesEntrypointIllustration from '../../assets/AuroraPreferencesEntrypointIllustration.png'
import { tID } from '../../utils/utils'
import { Image } from '../image/Image'

const AuroraPreferencesEntrypointPNG = styled(Image)<{ width: number; height: number }>(({ width, height }) => ({
  width: `${width}px`,
  height: `${height}px`,
}))

type Props = {
  width?: number
  height?: number
}

export const AuroraPreferencesEntrypointIllustration: FunctionComponent<Props> = ({ width = 274, height = 167 }) => {
  const { formatMessage } = useIntl()

  const accessibilityLabel = formatMessage({
    defaultMessage: 'Illustration of three people',
    description: 'Accessibility label for member preferences entrypoint illustration',
  })

  return (
    <AuroraPreferencesEntrypointPNG
      source={auroraPreferencesEntrypointIllustration}
      testID={tID('AuroraPreferencesEntrypointIllustration')}
      width={width}
      height={height}
      contentFit='contain'
      accessibilityIgnoresInvertColors
      accessibilityLabel={accessibilityLabel}
    />
  )
}
